import { useState } from 'react';
import { Button } from '@fabric-ds/react';

import { postSaveSearch } from '@/api/api';
import { SaveSearchModal } from '../saveSearchModal/SaveSearchModal';
import { useToast } from '@/scenes/resultPage/context/toast/ToastProvider';
import type { AutocompleteData, Filters } from '@/domain';

export interface SaveSearchProps {
    filters: Filters;
    autocompleteData: AutocompleteData;
    isLoggedIn: boolean;
}

export const SaveSearch = ({ filters, autocompleteData, isLoggedIn }: SaveSearchProps) => {
    const [isOpen, setOpen] = useState(false);
    const { toast } = useToast();

    const saveSearch = (name, notify) => {
        postSaveSearch(name, notify, filters)
            .then((response) => (response ? Promise.resolve() : Promise.reject()))
            .then(() => {
                toast({ message: 'Søket er lagret!' });
            })
            .catch(() => {
                toast({ message: 'Det skjedde en feil og søket ble ikke lagret. Prøv igjen!', type: 'error' });
            });
    };

    return (
        <div data-testid="save-search-box" className="md:px-16">
            <Button
                utility
                secondary
                data-testid="saveSearchButtonSecondary"
                className="hidden md:block w-full max-w-full mb-24"
                onClick={() => setOpen(true)}>
                Lagre søk
            </Button>
            <Button small data-testid="saveSearchButtonSmall" className="md:hidden" onClick={() => setOpen(true)}>
                Lagre søk
            </Button>
            <SaveSearchModal
                saveSearch={saveSearch}
                query={autocompleteData.selectedValue}
                isOpen={isOpen}
                setOpen={setOpen}
                isLoggedIn={isLoggedIn}
            />
        </div>
    );
};
